export const getOrderUrl = `/customers/orders`
export const getOrderListUrl = `/customers/orders/history`
export const getOrderDeliveryUrl = `/delivery/v1/delivery/details`
export const submitFeedbackUrl = `/customers/orders/feedback`
export const missingFeedbackUrl = `/customers/orders/feedback/pending`
export const orderHelpCenterUrl = `/guide/help_center/sections`
